import { Api } from '../api/root-api';

import {
  GetConnectedUsersApiRequest,
  GetConnectedUsersApiResponse,
  CreateLinkApiRequest,
  CreateLinkApiResponse,
  UpdateWahaQRCodeResponse,
  UpdateWahaQRCodeRequest,
  FetchWahaCodeRequest,
  FetchWahaCodeResponse,
  DeleteUserEntryResponse,
  DeleteUserEntryRequest,
  makeWabaAsDefaultResponse,
  makeWabaAsDefaultRequest,
  DisconnectWahaResponse,
  DisconnectWahaRequest,
  GetWaGroupMessagesRequest,
  GetWaGroupMessagesResponse,
  GenerateEmbeddedSignupLinkRequest,
  GenerateEmbeddedSignupLinkResponse,
  GetWahaGroupsResponse,
  GetWahaGroupsRequest,
  GetWahaGroupMembersResponse,
  GetWahaGroupMembersRequest,
  CreateBulkWAHACustomersResponse,
  CreateBulkWAHACustomersRequest,
  DeleteWabaAccountRequest,
  EmbeddedSignupCallbackResponse,
  EmbeddedSignupCallbackRequest,
  ToggleWhatsappCatalogueRequest,
  ReSyncWhatsappCatalogueRequest,
  UpdateFbmDetailsRequest,
  UpdateCatalogueDetailsRequest,
  EnableMarketingMessagesLiteRequest,
  WahaMessageReplayRequest,
  WahaMessageReplayResponse,
} from './model';

export const getConnectedUsersDataApi = Api.injectEndpoints({
  endpoints: (builder) => ({
    getConnectedUsersDataApi: builder.query<
      GetConnectedUsersApiResponse[],
      GetConnectedUsersApiRequest
    >({
      query(args) {
        return {
          url: `hub/orgs/api/whatsapp-config`,
          method: 'GET',
          params: args,
        };
      },
      providesTags: ['wabaUserData'],
    }),
    createLinkUserApi: builder.mutation<
      CreateLinkApiResponse,
      CreateLinkApiRequest
    >({
      query(arg) {
        return {
          url: `hub/orgs/api/whatsapp-config?sellerWorkspaceId=${arg?.params?.sellerWorkspaceId}`,
          method: 'POST',
          body: arg?.body,
          params: arg?.params,
        };
      },
    }),
    updateWahaQRCode: builder.query<
      UpdateWahaQRCodeResponse,
      UpdateWahaQRCodeRequest
    >({
      query(arg) {
        return {
          url: '/hub/orgs/api/whatsapp-config/waha-qr',
          method: 'GET',
          params: arg,
        };
      },
    }),
    fetchWahaCode: builder.mutation<
      FetchWahaCodeResponse,
      FetchWahaCodeRequest
    >({
      query(arg) {
        return {
          url: '/hub/orgs/api/whatsapp-config/waha-code',
          method: 'POST',
          params: {
            id: arg.id,
            sellerWorkspaceId: arg.sellerWorkspaceId,
          },
          body: arg.body,
        };
      },
    }),
    deleteUserEntry: builder.mutation<
      DeleteUserEntryResponse,
      DeleteUserEntryRequest
    >({
      query(arg) {
        return {
          url: '/hub/orgs/api/whatsapp-config',
          method: 'DELETE',
          params: arg,
        };
      },
    }),

    makeWabaAsDefault: builder.mutation<
      makeWabaAsDefaultResponse,
      makeWabaAsDefaultRequest
    >({
      query(arg) {
        const { sellerWorkspaceId, ...body } = arg;
        return {
          url: '/hub/orgs/api/whatsapp-config',
          method: 'PUT',
          params: { sellerWorkspaceId },
          body: body,
        };
      },
    }),

    disconnectWaha: builder.mutation<
      DisconnectWahaResponse,
      DisconnectWahaRequest
    >({
      query(arg) {
        return {
          url: '/hub/orgs/api/whatsapp-config/disconnect',
          method: 'POST',
          params: arg,
        };
      },
    }),
    getWaGroupMessages: builder.query<
      GetWaGroupMessagesResponse,
      GetWaGroupMessagesRequest
    >({
      query(arg) {
        return {
          url: `hub/communication-v2/api/waha/session/${arg.sessionId}/chats/${arg.messageId}/messages`,
          method: 'GET',
          params: {
            lte: arg.lte,
            gte: arg.gte,
            timestamp: arg.timestamp,
            limit: arg.limit,
            sellerWorkspaceId: arg.sellerWorkspaceId,
          },
        };
      },
    }),
    generateEmbeddedSignupLink: builder.query<
      GenerateEmbeddedSignupLinkResponse,
      GenerateEmbeddedSignupLinkRequest
    >({
      query(arg) {
        return {
          url: 'hub/orgs/api/whatsapp-config/generate-embedded-signup-link',
          method: 'GET',
          params: arg,
        };
      },
    }),

    getWahaGroups: builder.query<GetWahaGroupsResponse, GetWahaGroupsRequest>({
      query(arg) {
        return {
          url: '/hub/orgs/api/whatsapp-config/waha-groups',
          method: 'GET',
          params: arg,
        };
      },
    }),

    getWahaGroupMembers: builder.mutation<
      GetWahaGroupMembersResponse,
      GetWahaGroupMembersRequest
    >({
      query(arg) {
        const { body, ...otherparams } = arg;
        return {
          url: '/hub/orgs/api/whatsapp-config/waha-groups-members',
          method: 'POST',
          params: otherparams,
          body: body,
        };
      },
    }),

    createBulkWAHACustomers: builder.mutation<
      CreateBulkWAHACustomersResponse,
      CreateBulkWAHACustomersRequest
    >({
      query(arg) {
        const { body, ...otherparams } = arg;
        return {
          url: `/hub/orgs/api/waha/customers/create/bulk/${otherparams?.sellerWorkspaceId}`,
          method: 'POST',
          params: otherparams,
          body: body,
        };
      },
    }),

    deleteWabaAccount: builder.mutation<any, DeleteWabaAccountRequest>({
      query(arg) {
        return {
          url: '/hub/orgs/api/whatsapp-config',
          method: 'DELETE',
          params: arg.params,
        };
      },
    }),
    embeddedSignupCallback: builder.mutation<
      EmbeddedSignupCallbackResponse,
      EmbeddedSignupCallbackRequest
    >({
      query: (args) => ({
        url: `hub/orgs/api/whatsapp-config/embedded-signup-webhook`,
        method: 'POST',
        body: args,
        params: {
          sellerWorkspaceId: args.sellerWorkspaceId,
        },
      }),
    }),
    reSyncWhatsappCatalogue: builder.mutation<
      any,
      ReSyncWhatsappCatalogueRequest
    >({
      query: (args) => ({
        url: `hub/orgs/api/whatsapp-config/catalog-sync/${args.params?.sellerWorkspaceId}`,
        method: 'POST',
        body: args.body,
        params: args.params,
      }),
    }),

    updateFBMDetails: builder.mutation<any, UpdateFbmDetailsRequest>({
      query: (args) => ({
        url: `hub/orgs/api/whatsapp-config/fbm-details/update/${args.params.sellerWorkspaceId}`,
        method: 'POST',
        body: args.body,
        params: args.params,
      }),
    }),

    updateCatalogDetails: builder.mutation<any, UpdateCatalogueDetailsRequest>({
      query: (args) => ({
        url: `hub/orgs/api/whatsapp-config/catalogue/update/${args.params.sellerWorkspaceId}`,
        method: 'PUT',
        body: args.body,
        params: args.params,
      }),
    }),

    apiLogsWhatsapp: builder.mutation<any, any>({
      query: (args) => ({
        url: `api/log`,
        method: 'POST',
        body: args,
      }),
    }),
    toggleWhatsappCatalogue: builder.mutation<
      any,
      ToggleWhatsappCatalogueRequest
    >({
      query: (args) => ({
        url: `/hub/orgs/api/whatsapp-config`,
        method: 'PUT',
        body: args.body,
        params: args.params,
      }),
    }),
    enableMarketingMessagesLite: builder.mutation<
      any,
      EnableMarketingMessagesLiteRequest
    >({
      query: (args) => ({
        url: `hub/orgs/api/whatsapp-config/marketing-messages-lite/enable`,
        method: 'POST',
        body: args.body,
        params: args.params,
      }),
    }),
    wahaMessageReplay: builder.mutation<
      WahaMessageReplayResponse,
      WahaMessageReplayRequest
    >({
      query: (args) => ({
        url: `hub/orgs/api/whatsapp-config/waha-message-replay`,
        method: 'POST',
        body: args.body,
        params: args.params,
      }),
    }),
  }),
});

export const {
  useLazyGetConnectedUsersDataApiQuery,
  useCreateLinkUserApiMutation,
  useLazyUpdateWahaQRCodeQuery,
  useFetchWahaCodeMutation,
  useDeleteUserEntryMutation,
  useDisconnectWahaMutation,
  useMakeWabaAsDefaultMutation,
  useLazyGetWaGroupMessagesQuery,
  useLazyGenerateEmbeddedSignupLinkQuery,
  useLazyGetWahaGroupsQuery,
  useGetWahaGroupMembersMutation,
  useCreateBulkWAHACustomersMutation,
  useDeleteWabaAccountMutation,
  useEmbeddedSignupCallbackMutation,
  useReSyncWhatsappCatalogueMutation,
  useToggleWhatsappCatalogueMutation,
  useApiLogsWhatsappMutation,
  useUpdateFBMDetailsMutation,
  useUpdateCatalogDetailsMutation,
  useEnableMarketingMessagesLiteMutation,
  useWahaMessageReplayMutation,
} = getConnectedUsersDataApi;
